export const addImage=(imageSource)=>{
    return{
        type:"addImage",
        imageKey:Date.now(),
        newImage:imageSource
    }
} 